// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideMenu_wrapper__T8vju","logoWrapper":"SideMenu_logoWrapper__2TxCF","logo":"SideMenu_logo__6hvBg","menu":"SideMenu_menu__1Tzku"};